/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface NoticeMessageListPayload {
    kind: string;
    messageId?: string;
    organizationId?: string;
}

export interface MsgListItem {
    messageId: string;
    messageList: Array<string>;
    startDateStr: string;
    title: string;
    organizationId: string;
    status: string;
    messageType: string;
    contact: string;
    message: string;
}

export interface NoticeMessageListResponse {
    msgList: MsgListItem[];
}

class NoticeMessageListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "noticeMessageList");
    }

    public async noticeMessageList(
        payload: NoticeMessageListPayload,
        resolved: (json: NoticeMessageListResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as NoticeMessageListResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default NoticeMessageListService;
